const Text = ({ item }) => (
  <div
    style={{
      width: "100%",
      height: "calc(100% - 12px)",
      overflow: "hidden",
      padding: 12,
    }}
  >
    <div
      dangerouslySetInnerHTML={{ __html: item.short }}
      style={{
        // display: "-webkit-box",
        // WebkitLineClamp: 8,
        // WebkitBoxOrient: "vertical",
        overflow: "hidden",
      }}
      className="textrrrr"
    />
  </div>
);
export default Text;
